import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const setNetworkState = (
    state: GameState,
    action: PayloadAction<{
        online?: boolean;
        notToReconnect?: boolean;
        needUserConfirm?: boolean;
    }>
) => {
    const { online, notToReconnect, needUserConfirm } = action.payload;

    if (online != undefined) state.online = online;
    if (notToReconnect != undefined) state.notToReconnect = notToReconnect;
    if (needUserConfirm != undefined) state.needUserConfirm = needUserConfirm;
};
const setCurrentProxyID = (
    state: GameState,
    action: PayloadAction<{ proxyID: number }>
) => {
    const { proxyID } = action.payload;

    state.proxyID = proxyID;
};

const setCurrentVideoIndex = (
    state: GameState,
    action: PayloadAction<{ currentVideoIndex: number }>
) => {
    const { currentVideoIndex } = action.payload;

    state.currentVideoIndex = currentVideoIndex;
};

// const setInitBlock = (
//     state: GameState,
//     action: PayloadAction<{ block: boolean }>
// ) => {
//     const { block } = action.payload;

//     state.initBlock = block;
// };
// const setOnceEvent = (
//     state: GameState,
//     action: PayloadAction<{ gameId: number; event: string }>
// ) => {
//     const { gameId, event } = action.payload;
//     if (state.currentGameId === gameId) {
//         state.onceEvent = event;
//     }
// };
// const onDoubleBet = (
//     state: GameState,
//     action: PayloadAction<{ onClick: boolean }>
// ) => {
//     const { onClick } = action.payload;
//     state.doubleBet = onClick;
// };
// const onReBet = (
//     state: GameState,
//     action: PayloadAction<{ onClick: boolean }>
// ) => {
//     const { onClick } = action.payload;
//     state.reBet = onClick;
// };
const resetAll = (state: GameState) => {
    // state.doubleBet = initialGameState.doubleBet;
    // state.reBet = initialGameState.reBet;
    if (state.onceEvent != initialGameState.onceEvent)
        state.onceEvent = initialGameState.onceEvent;
    if (state.resetRoulSelectedTypes != initialGameState.resetRoulSelectedTypes)
        state.resetRoulSelectedTypes = initialGameState.resetRoulSelectedTypes;
};
const setLastVideo = (state: GameState, action: PayloadAction<string>) => {
    if (state.lastVideo != action.payload) state.lastVideo = action.payload;
};
const setVideoLibraryVersion = (
    state: GameState,
    action: PayloadAction<string>
) => {
    if (state.videoLibraryVersion != action.payload)
        state.videoLibraryVersion = action.payload;
};
const onResetRoulSelectedTypes = (state: GameState) => {
    const count = state.resetRoulSelectedTypes;
    state.resetRoulSelectedTypes = count + 1;
};
const updateIsAutoConfirm = (
    state: GameState,
    action: PayloadAction<boolean>
) => {
    if (state.isAutoConfirm !== action.payload)
        state.isAutoConfirm = action.payload;
};

export type BaccaratBetsHistory = {
    hostId: number;
    gameId: number;
    betType: number;
    betAmount: number;
    isResultRelease: boolean;
    isCancel: boolean;
    winAmount: number;
};

export type GameState = {
    proxyID: number;
    currentVideoIndex: number;
    // doubleBet: boolean;
    // reBet: boolean;
    online: boolean;
    notToReconnect: boolean;
    needUserConfirm: boolean;
    onceEvent: string;
    lastVideo: string;
    videoLibraryVersion: string;
    initBlock: boolean; //
    resetRoulSelectedTypes: number; // for roulette
    isAutoConfirm: boolean; //only for hook use, UI use GlobalUserDataContext
};
const initialGameState = {
    proxyID: 0,
    currentVideoIndex: 0,
    // doubleBet: false,
    // reBet: false,
    currentGameId: -1,
    currentGameState: -1,
    online: false,
    notToReconnect: false,
    needUserConfirm: false,
    onceEvent: '',
    lastVideo: '',
    videoLibraryVersion: '',
    waitingBetResult: false,
    initBlock: false,
    resetRoulSelectedTypes: 0,
    isAutoConfirm: false,
    openTable: [] as number[],
} as GameState;
export const GAME_KEY = 'app::game';
const gameSlice = createSlice({
    name: GAME_KEY,
    initialState: initialGameState,
    reducers: {
        setNetworkState,
        setCurrentProxyID,
        setCurrentVideoIndex,
        // setOnceEvent,
        // onDoubleBet,
        // onReBet,
        resetAll,
        setLastVideo,
        setVideoLibraryVersion,
        // setInitBlock,
        onResetRoulSelectedTypes,
        updateIsAutoConfirm,
    },
});
export const gameSliceReducer = gameSlice.reducer;
export const gameSliceActions = gameSlice.actions;
